import React from 'react'
import { StaticPageWrapper } from 'components/common/StaticPageWrapper/StaticPageWrapper'

const RefundPolicy: React.FC = () => {
    return (
        <StaticPageWrapper title="Refund Policy">
            <p>
                All purchases within the platform are final. However, there are certain circumstances where refunds will
                be eligible:
            </p>
            <ul>
                <li>If a scheduled live stream is canceled or rescheduled and the user can no longer attend</li>
                <li>
                    If a technology issue arises that does not allow the user to attend or watch the live stream, and is
                    at the fault of Novel
                </li>
            </ul>
            <p>
                Any request for a refund must be made within 24 hours from the start time of the live stream which the
                pass was purchased for. All requests should be sent to{' '}
                <a
                    className="text-dark-grey"
                    href="mailto:support@benovel.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    support@benovel.com
                </a>
                .
            </p>
        </StaticPageWrapper>
    )
}

export default RefundPolicy
